module.exports = __webpack_public_path__ + "static/bg-banner-pl-offer-ab3615698ff73cfc0c4d049a40945ea8.png";